import { render } from "./Libraries.vue?vue&type=template&id=34803edc&scoped=true&ts=true"
import script from "./Libraries.vue?vue&type=script&lang=ts"
export * from "./Libraries.vue?vue&type=script&lang=ts"

import "./Libraries.vue?vue&type=style&index=0&id=34803edc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34803edc"]])

export default __exports__